import { msalInstance, loginRequest } from "../auth/msalConfig";
import { InteractionStatus } from "@azure/msal-browser";
import { client } from "./"; // your axios client
import { scheduleTokenRenewal, acquireApiToken } from "../auth/token-renewal";

// Redux constants
const SET_LOGIN_PENDING = "SET_LOGIN_PENDING";
const SET_LOGIN_SUCCESS = "SET_LOGIN_SUCCESS";
const SET_LOGIN_ERROR = "SET_LOGIN_ERROR";

// Redux helpers
function setLoginPending() { return { type: SET_LOGIN_PENDING }; }
function setLoginSuccess(user) { return { type: SET_LOGIN_SUCCESS, user }; }
function setLoginError(error) { return { type: SET_LOGIN_ERROR, error }; }

// Main login status checker
export function checkLoginStatus() {
    return async dispatch => {
        dispatch(setLoginPending());
        try {
            let accounts = msalInstance.getAllAccounts();
            let account = accounts[0];

            if (!account) {
                const login = await msalInstance.loginPopup(loginRequest);
                account = login.account;
            }

            const apiToken = await acquireApiToken(account);
            sessionStorage.setItem("jwt", apiToken);

            // Schedule auto-renewal
            scheduleTokenRenewal(account);

            const profileResponse = await client.post("/profile", {
                USER_EDP_AD: account.username
            });

            const profile =
                profileResponse.data && profileResponse.data.length > 0
                    ? profileResponse.data[0]
                    : null;

            if (!profile) {
                dispatch(setLoginError("User profile not found"));
                return;
            }

            // Dispatch user object
            dispatch(setLoginSuccess({
                userid: account.username,
                username: account.name,
                token: apiToken,
                profile
            }));

        } catch (err) {
            console.error("Login error:", err);
            dispatch(setLoginError(err.toString()));
        }
    };
}

export function loginUser() {
    return () => {
        if (msalInstance.getAllAccounts().length === 0 &&
            msalInstance.getInteractionStatus() !== InteractionStatus.InProgress) {
            msalInstance.loginRedirect();
        }
    };
}

export function logoutUser() {
    return () => {
        sessionStorage.clear();
        msalInstance.logoutPopup();
    };
}



// WEBPACK FOOTER //
// ./src/actions/login-actions.js